import { en } from './en';
import { nn } from './nn';
import { nb } from './nb';
export var txt = {
    nb: nb,
    nn: nn,
    en: en,
};
